module.exports = __webpack_public_path__ + "static/media/wizaz.3f7c2fce.svg";